import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { RadioAbstract } from './RadioAbstract';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
export var Radio = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(RadioAbstract, _extends({
    ref: ref
  }, props));
});
export default Radio;